<form [formGroup]="bankForm">
  <div class="row">
    <div class="col-md-6">
      <div class="mb-3" *ngIf="bankAccounts.length">
        <h3 class="text-muted mb-2">Bank Accounts</h3>
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Country</th>
              <th>Created</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let account of bankAccounts">
              <td>{{ account.country }}</td>
              <td>{{ account.created | date:'d MMM y' }}</td>
              <td>
                <span class="badge badge-success" *ngIf="account.selected">Selected</span>
              </td>
              <td class="text-right">
                <app-button text="Select" type="button" variant="secondary" size="sm" className="mr-1" *ngIf="!account.selected && canWritePaymentInfo"
                  [disabled]="processing" (clicked)="selectBankAccount(account.optionId)" />
                <app-button text="View" type="button" variant="tertiary" size="sm" className="mr-1" *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails)"
                  [disabled]="processing" (clicked)="viewBankAccount(account)" />
                <app-button text="Remove" type="button" variant="info" size="sm" *ngIf="canWritePaymentInfo"
                  [disabled]="processing" (clicked)="confirmRemoveBankAccount(account.optionId)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <mat-accordion multi="false">
        <mat-expansion-panel [disabled]="!canWritePaymentInfo" [expanded]="canWritePaymentInfo">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <label>Set up Nmible Bank Account</label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <table class="simple-form">
            <tbody>
              <ng-container *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoWrite)">

                <tr>
                  <th><label for="country">Country <sup>*</sup></label></th>
                  <td>
                    <div class="form-group">
                      <app-autosuggest-dropdown-input [options]="countries" [parentForm]="bankForm"
                        controlName="country" placeholder="Select country..."></app-autosuggest-dropdown-input>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="!loadingMethods && bankMethods.length > 0">
                  <th><label>Payment Provider <sup>*</sup></label></th>
                  <td>
                    <div class="form-group">
                      <app-dropdown-input
                        [options]="getProviderOptions()"
                        [parentForm]="bankForm"
                        name="provider"
                        [selectedValue]="bankForm.get('provider').value">
                      </app-dropdown-input>
                      <span class="validation-error"
                        *ngIf="bankForm.get('provider').touched && bankForm.get('provider').hasError('required')">Payment
                        Provider is required</span>
                    </div>
                  </td>
                </tr>

                <ng-container *ngIf="loadingMethods">
                  <tr>
                    <td colspan="2">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading bank fields...
                    </td>
                  </tr>
                </ng-container>

                <ng-container *ngIf="!loadingMethods && bankMethod">
                  <tr>
                    <td colspan="2">
                      <hr class="my-2">
                      <strong class="d-block mb-2">Account Holder</strong>
                      <small class="text-muted d-block mb-2">Name and email used to register the bank account with Nmible.</small>
                    </td>
                  </tr>
                  <tr>
                    <th><label for="givenName">First Name <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="givenName" class="form-control" formControlName="givenName">
                        <span class="validation-error"
                          *ngIf="bankForm.get('givenName').touched && bankForm.get('givenName').hasError('required')">First
                          Name is required</span>
                        <span class="validation-error"
                          *ngIf="bankForm.get('givenName').touched && bankForm.get('givenName').hasError('pattern')">First
                          Name can only contain letters</span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th><label for="middleName">Middle Name</label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="middleName" class="form-control" formControlName="middleName">
                        <span class="validation-error"
                          *ngIf="bankForm.get('middleName').touched && bankForm.get('middleName').hasError('pattern')">Middle
                          Name can only contain letters</span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th><label for="familyName">Last Name <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <input type="text" id="familyName" class="form-control" formControlName="familyName">
                        <span class="validation-error"
                          *ngIf="bankForm.get('familyName').touched && bankForm.get('familyName').hasError('required')">Last
                          Name is required</span>
                        <span class="validation-error"
                          *ngIf="bankForm.get('familyName').touched && bankForm.get('familyName').hasError('pattern')">Last
                          Name can only contain letters</span>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th><label for="email">Email <sup>*</sup></label></th>
                    <td>
                      <div class="form-group">
                        <input type="email" id="email" class="form-control" formControlName="email">
                        <span class="validation-error"
                          *ngIf="bankForm.get('email').touched && bankForm.get('email').hasError('required')">Email
                          is required</span>
                        <span class="validation-error"
                          *ngIf="bankForm.get('email').touched && bankForm.get('email').hasError('pattern')">Email
                          is invalid</span>
                      </div>
                    </td>
                  </tr>
                </ng-container>

                <ng-container *ngIf="!loadingMethods && bankMethod && bankFieldProperties.length > 0"
                  formGroupName="accountFields">
                  <tr>
                    <td colspan="2">
                      <hr class="my-2">
                      <strong class="d-block mb-2">Bank Details</strong>
                    </td>
                  </tr>
                  <ng-container *ngFor="let prop of bankFieldProperties">

                    <!-- Plain text field -->
                    <tr *ngIf="!isEnumField(prop) && !isObjectField(prop)">
                      <th>
                        <label [for]="prop.propertyName">
                          {{ prop.title }}
                          <sup *ngIf="isRequiredField(prop.propertyName)">*</sup>
                        </label>
                      </th>
                      <td>
                        <div class="form-group">
                          <app-datepickerv2-input *ngIf="datePickerPropertyNames.has(prop.propertyName)"
                            [parentForm]="datePickerGroup" [controlName]="prop.propertyName"
                            [min]="dateOfBirthMin" [max]="dateOfBirthMax" startView="multi-year"
                            (touched)="onDatePickerTouched(prop.propertyName)">
                          </app-datepickerv2-input>
                          <input *ngIf="!datePickerPropertyNames.has(prop.propertyName)" type="text"
                            [id]="prop.propertyName" class="form-control" [formControlName]="prop.propertyName">
                          <small *ngIf="prop.description" class="form-text text-muted">{{ prop.description }}</small>
                          <span class="validation-error" *ngIf="datePickerErrorFor(prop.propertyName)">
                            {{ prop.title }} {{ datePickerErrorFor(prop.propertyName) }}
                          </span>
                          <span class="validation-error"
                            *ngIf="!datePickerErrorFor(prop.propertyName) && accountFieldsGroup.get(prop.propertyName)?.touched && accountFieldsGroup.get(prop.propertyName)?.hasError('required')">
                            {{ prop.title }} is required
                          </span>
                          <span class="validation-error"
                            *ngIf="accountFieldsGroup.get(prop.propertyName)?.touched && accountFieldsGroup.get(prop.propertyName)?.hasError('pattern')">
                            {{ prop.title }} format is invalid
                          </span>
                        </div>
                      </td>
                    </tr>

                    <!-- Enum dropdown field -->
                    <tr *ngIf="isEnumField(prop)">
                      <th>
                        <label>
                          {{ prop.title }}
                          <sup *ngIf="isRequiredField(prop.propertyName)">*</sup>
                        </label>
                      </th>
                      <td>
                        <div class="form-group">
                          <app-dropdown-input
                            [options]="getEnumOptions(prop)"
                            [parentForm]="accountFieldsGroup"
                            [name]="prop.propertyName"
                            [selectedValue]="accountFieldsGroup.get(prop.propertyName)?.value">
                          </app-dropdown-input>
                          <small *ngIf="prop.description" class="form-text text-muted">{{ prop.description }}</small>
                          <span class="validation-error"
                            *ngIf="accountFieldsGroup.get(prop.propertyName)?.touched && accountFieldsGroup.get(prop.propertyName)?.hasError('required')">
                            {{ prop.title }} is required
                          </span>
                        </div>
                      </td>
                    </tr>

                    <!-- Object field (e.g. Address) — renders labelled sub-fields -->
                    <ng-container *ngIf="isObjectField(prop)" [formGroupName]="prop.propertyName">
                      <tr>
                        <td colspan="2">
                          <label class="font-weight-bold">
                            {{ prop.title }}
                            <sup *ngIf="isRequiredField(prop.propertyName)">*</sup>
                          </label>
                        </td>
                      </tr>
                      <ng-container *ngFor="let subKey of getSubFieldKeys(prop)">
                        <tr>
                          <th>
                            <label [for]="prop.propertyName + '_' + subKey">
                              {{ getSubProperty(prop, subKey).title }}
                              <sup *ngIf="isRequiredSubField(prop, subKey)">*</sup>
                            </label>
                          </th>
                          <td>
                            <div class="form-group">
                              <app-dropdown-input *ngIf="isEnumSubField(getSubProperty(prop, subKey))"
                                [options]="getSubFieldOptions(getSubProperty(prop, subKey))"
                                [parentForm]="getSubFieldGroup(prop)"
                                [name]="subKey"
                                [selectedValue]="getSubFieldGroup(prop).get(subKey)?.value">
                              </app-dropdown-input>
                              <input *ngIf="!isEnumSubField(getSubProperty(prop, subKey))"
                                type="text" [id]="prop.propertyName + '_' + subKey" class="form-control"
                                [formControlName]="subKey">
                              <span class="validation-error"
                                *ngIf="getSubFieldGroup(prop).get(subKey)?.touched && getSubFieldGroup(prop).get(subKey)?.hasError('required')">
                                {{ getSubProperty(prop, subKey).title }} is required
                              </span>
                            </div>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>

                  </ng-container>
                </ng-container>

                <ng-container *ngIf="!loadingMethods && bankForm.get('country').value && !bankMethod">
                  <tr>
                    <td colspan="2">
                      <div class="alert alert-warning mt-2">
                        No bank payment methods available for the selected country.
                      </div>
                    </td>
                  </tr>
                </ng-container>

                <tr
                  *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) && authService.hasPermission(Permissions.PatientPaymentInfoWrite) && bankMethod">
                  <th></th>
                  <td>
                    <button [disabled]="bankForm.invalid || processing || loadingMethods"
                      class="btn btn-primary test-connection-btn w-100" (click)="createBankAccount()">
                      <span *ngIf="processing" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                      <span *ngIf="!processing">Create Bank Account</span>
                    </button>
                  </td>
                </tr>

              </ng-container>
            </tbody>
          </table>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="authService.hasPermission(Permissions.PatientPaymentInfoReadBankDetails) && authService.hasPermission(Permissions.PatientPaymentInfoWrite)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <label>Copy Bank Details from Another Patient</label>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <table class="simple-form">
            <tbody>
              <tr>
                <th><label>Search Patient</label></th>
                <td>
                  <div class="form-group">
                    <app-patient-autocomplete [parentForm]="copySourceForm" controlName="sourcePatientId" [globalOnly]="true"
                      placeholder="Search by name, email or patient code..." (selectionChanged)="onSourcePatientSelected($event)">
                    </app-patient-autocomplete>
                  </div>
                </td>
              </tr>

              <tr *ngIf="loadingSourceAccounts">
                <td colspan="2">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Loading bank accounts for selected patient...
                </td>
              </tr>

              <tr *ngIf="sourceTrialOptions.length > 0">
                <th><label>Select Trial Enrollment</label></th>
                <td>
                  <div class="form-group">
                    <app-dropdown-input
                      [options]="sourceTrialOptions"
                      [parentForm]="copySourceForm"
                      name="sourceTrialId"
                      [selectedValue]="copySourceForm.get('sourceTrialId').value"
                      (selectValueChanged)="onSourceTrialSelected($event)">
                    </app-dropdown-input>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</form>

<app-confirm-action-modal #confirmRemoveBankAccountModal (confirmed)="removeBankAccount($event)" />

<app-modal #assignBankDetailsModal [size]="ModalSize.Md">
  <div class="modal-header">
    <h2 class="modal-title">Copy Bank Details</h2>
  </div>

  <div class="modal-body" *ngIf="sourceBankDetails">
    <p>Are you sure you want to assign these details to {{ patientDetail?.firstName }} {{ patientDetail?.lastName }}?</p>

    <div class="row mb-2">
      <div class="col-4 text-muted">Source Patient</div>
      <div class="col-8">{{ sourcePatientName }}<ng-container *ngIf="selectedSourceAccount"> ({{ selectedSourceAccount.trialCode }})</ng-container></div>
    </div>
    <div class="row mb-2">
      <div class="col-4 text-muted">Country</div>
      <div class="col-8">{{ sourceBankDetails.country }}</div>
    </div>
    <div class="row mb-2" *ngIf="sourceIdentityFields['_provider']">
      <div class="col-4 text-muted">Provider</div>
      <div class="col-8">{{ sourceIdentityFields['_provider'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="sourceIdentityFields['givenName']">
      <div class="col-4 text-muted">First Name</div>
      <div class="col-8">{{ sourceIdentityFields['givenName'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="sourceIdentityFields['middleName']">
      <div class="col-4 text-muted">Middle Name</div>
      <div class="col-8">{{ sourceIdentityFields['middleName'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="sourceIdentityFields['familyName']">
      <div class="col-4 text-muted">Last Name</div>
      <div class="col-8">{{ sourceIdentityFields['familyName'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="sourceIdentityFields['email']">
      <div class="col-4 text-muted">Email</div>
      <div class="col-8">{{ sourceIdentityFields['email'] }}</div>
    </div>
    <div class="row mb-2" *ngFor="let entry of sourceAccountFields | keyvalue">
      <div class="col-4 text-muted">{{ getSourceFieldTitle(entry.key) }}</div>
      <div class="col-8">{{ entry.value }}</div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="cancelAssignBankDetails()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>
      <div class="col-6">
        <button [disabled]="processing" class="btn btn-primary" (click)="confirmAssignBankDetails()">
          <span *ngIf="processing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!processing">Confirm</span>
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #viewBankDetailsModal [size]="ModalSize.Md">
  <div class="modal-header">
    <h2 class="modal-title">Bank Account Details</h2>
  </div>

  <div class="modal-body" *ngIf="viewedBankAccount">
    <div class="row mb-2">
      <div class="col-4 text-muted">Country</div>
      <div class="col-8">{{ viewedBankAccount.country }}</div>
    </div>
    <div class="row mb-2" *ngIf="viewedIdentityFields['_provider']">
      <div class="col-4 text-muted">Provider</div>
      <div class="col-8">{{ viewedIdentityFields['_provider'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="viewedIdentityFields['givenName']">
      <div class="col-4 text-muted">First Name</div>
      <div class="col-8">{{ viewedIdentityFields['givenName'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="viewedIdentityFields['middleName']">
      <div class="col-4 text-muted">Middle Name</div>
      <div class="col-8">{{ viewedIdentityFields['middleName'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="viewedIdentityFields['familyName']">
      <div class="col-4 text-muted">Last Name</div>
      <div class="col-8">{{ viewedIdentityFields['familyName'] }}</div>
    </div>
    <div class="row mb-2" *ngIf="viewedIdentityFields['email']">
      <div class="col-4 text-muted">Email</div>
      <div class="col-8">{{ viewedIdentityFields['email'] }}</div>
    </div>
    <div class="row mb-2" *ngFor="let entry of viewedAccountFields | keyvalue">
      <div class="col-4 text-muted">{{ getViewFieldTitle(entry.key) }}</div>
      <div class="col-8">{{ entry.value }}</div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12">
        <a (click)="closeViewBankDetails()" class="btn btn-secondary w-100" data-dismiss="modal">Close</a>
      </div>
    </div>
  </div>
</app-modal>
